// Fallback only, for a row that carries no documentsTotal. It is the size of
// the baseline checklist: 10 since the two High School Transcript entries were
// merged into one. The real denominator varies per student.
export const APPLICATION_DOCUMENTS_MAX = 10
